/**
 * @file automatically generated from MApp.Endpoints.AppEngineController
 */

import { MetadataClient } from '../metadata-client';
import { IGuidObject } from '../models';

export class AppEngineClient extends MetadataClient {

	public static getBrowserAppConfig(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getLegacyBrowserRuntime(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/legacyruntime/${encodeURIComponent(id)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getBrowserAppName(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}/name`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static updateBrowserAppConfig(id: string, config: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(config),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getBrowserRuntimeConfig(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime/${encodeURIComponent(id)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getWarehousePrivateFile(name: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<number[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/warehousefiles/private/${encodeURIComponent(name)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getWarehousePublicFile(name: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/warehousefiles/public/${encodeURIComponent(name)}`, {
				cache: 'no-cache',
				...requestInit
			}),
			true
		);
	}

	public static saveBrowserRuntime(jsonConfig: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IGuidObject>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(jsonConfig),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static cloneBrowserApp(id: string, newName: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browsermapps/clone/${encodeURIComponent(id)}?newName=${encodeURIComponent(newName)}`, {
				method: 'POST',
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static updateBrowserRuntime(id: string, jsonConfig: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(jsonConfig),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static deleteBrowserRuntime(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime/${encodeURIComponent(id)}`, {
				method: 'DELETE',
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getAttachment(id: string, runtimeName: string, attachmentName: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}/runtimes/${encodeURIComponent(runtimeName)}/attachments/${encodeURIComponent(attachmentName)}`, {
				cache: 'no-cache',
				...requestInit
			}),
			true
		);
	}
}
